import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/loading.tsx
import { jsx } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsx(
  "path",
  {
    clipRule: "evenodd",
    d: "M12 2.69767C12 3.08299 11.6865 3.3924 11.3024 3.42321C7.10656 3.75983 3.75983 7.10656 3.42321 11.3024C3.3924 11.6865 3.08299 12 2.69767 12C2.31236 12 1.99747 11.6866 2.02397 11.3022C2.36632 6.33548 6.33548 2.36632 11.3022 2.02397C11.6866 1.99747 12 2.31236 12 2.69767ZM12 21.3023C12 20.917 12.3134 20.6076 12.6975 20.5768C16.8934 20.2401 20.2401 16.8934 20.5768 12.6975C20.6076 12.3134 20.917 12 21.3023 12C21.6876 12 22.0025 12.3134 21.976 12.6978C21.6337 17.6645 17.6645 21.6337 12.6978 21.976C12.3134 22.0025 12 21.6876 12 21.3023Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
var Loading = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  Loading
};
